<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="content-right">
    <div class="content-wrapper container-xxl p-0">
      <div class="content-header row" />
      <div class="content-body">
        <!-- overlay container -->
        <div
          class="body-content-overlay"
          :class="{ 'show': isShowSidebar }"
          @click="toggleSidebarFile"
        />
        <!-- file manager app content starts -->
        <div class="file-manager-main-content">
          <!-- search area start -->
          <div class="file-manager-content-header py-1">
            <!-- ChevronDownIcon  -->
            <div class="d-flex align-items-center">
              <div
                class="sidebar-toggle d-block d-xl-none float-start align-middle ms-1 mb-1"
                @click="toggleSidebarFile"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                  class="font-medium-5"
                />
                Thư mục
              </div>
              <b-button
                v-b-modal.modalSearchFile
                variant="outline-primary"
                size="md"
                class="btn-icon mr-1"
              >
                Tìm kiếm <feather-icon icon="SearchIcon" />
              </b-button>
              <b-button
                variant="outline-primary"
                size="md"
                class="btn-icon mr-1"
                @click="showModalUpload"
              >
                <feather-icon icon="ArrowUpCircleIcon" /> Tải lên
              </b-button>
              <div class="ml-auto d-flex align-items-center">
                <div
                  class="file-actions"
                  :class="{ 'show': itemSelected }"
                >
                  <feather-icon
                    icon="RefreshCwIcon"
                    class="font-medium-2 cursor-pointer mr-2"
                    @click="refreshCategory"
                  />
                  <feather-icon
                    v-if="itemSelected.itemType == 'file'"
                    icon="ArrowDownCircleIcon"
                    class="font-medium-2 cursor-pointer mr-2 d-none"
                  />
                  <feather-icon
                    v-if="allowDelete"
                    icon="TrashIcon"
                    class="font-medium-2 cursor-pointer mr-2"
                    @click="deleteSelectedItem"
                  />
                  <feather-icon
                    v-if="itemSelected.itemType == 'file'"
                    icon="InfoIcon"
                    class="font-medium-2 cursor-pointer mr-2"
                    @click="showFileInfo"
                  />
                </div>
                <b-button-group class="btn-group view-toggle ms-50">
                  <b-button
                    :variant="isGrid ? 'outline-secondary' : 'primary'"
                    class="btn-icon"
                    @click="setListLayout('list')"
                  >
                    <feather-icon icon="ListIcon" />
                  </b-button>
                  <b-button
                    :variant="!isGrid ? 'outline-secondary' : 'primary'"
                    class="btn-icon"
                    @click="setListLayout('grid')"
                  >
                    <feather-icon icon="GridIcon" />
                  </b-button>
                </b-button-group>
              </div>
            </div>
          </div>
          <!-- search area ends here -->
          <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="file-manager-content-body scroll-area"
          >
            <!-- Folders Container Starts -->
            <div
              class="view-container"
              :class="isGrid ? '' : 'list-view'"
            >
              <h6 class="files-section-title mt-25 mb-75">
                Thư mục
              </h6>
              <div class="files-header">
                <h6 class="fw-bold mb-0">
                  Tên file
                </h6>
                <div>
                  <h6 class="fw-bold file-item-size d-inline-block mb-0">
                    Kích thước
                  </h6>
                  <h6 class="fw-bold file-last-modified d-inline-block mb-0">
                    Sửa đổi lần cuối
                  </h6>
                  <h6 class="fw-bold d-inline-block me-1 mb-0">
                    Hành động
                  </h6>
                </div>
              </div>
              <div class="card file-manager-item folder level-up d-none">
                <div class="card-img-top file-logo-wrapper">
                  <div class="d-flex align-items-center justify-content-center w-100">
                    <feather-icon icon="CornerLeftUpIcon" />
                  </div>
                </div>
                <div class="card-body ps-2 pt-0 pb-1">
                  <div class="content-wrapper">
                    <p class="card-text file-name mb-0">
                      ...
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-for="item in categoryItems"
                :key="item.id"
                class="card file-manager-item folder"
                :class="{ 'selected': resolveSelectedClass(item.ID) }"
              >
                <!-- <b-form-checkbox
                  v-model="itemSelected"
                  :value="item.ID"
                  class="custom-control-primary d-none"
                  @change="toggleSelect(item)"
                                                    /> -->
                <div
                  v-if="item.show"
                  class="card-img-top file-logo-wrapper"
                  @click="onClickCategory(item)"
                >
                  <div class="dropdown float-end d-none">
                    <feather-icon
                      icon="MoreVerticalIcon"
                      class="toggle-dropdown mt-n25"
                    />
                  </div>
                  <div class="d-flex align-items-center justify-content-center w-100 h-100">
                    <feather-icon icon="FolderIcon" />
                  </div>
                </div>
                <div
                  class="card-body"
                  @click="onClickCategory(item)"
                >
                  <div class="content-wrapper">
                    <p class="card-text file-name mb-0">
                      {{ item.name }}
                    </p>
                    <p class="card-text file-size mb-0 d-none">
                      0
                    </p>
                    <p class="card-text file-date">
                      {{ convertDate(item.created_at) }}
                    </p>
                  </div>
                  <small class="file-accessed text-muted d-none">Truy cập lần cuối: 21 giờ trước</small>
                </div>
              </div>
              <div
                class="flex-grow-1 align-items-center no-result mb-3"
                :class="{ 'd-none': categoryItems }"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  class="me-50"
                /> Không có kết quả
              </div>
            </div>
            <!-- /Folders Container Ends -->
            <!-- Files Container Starts -->
            <div
              class="view-container"
              :class="isGrid ? '' : 'list-view'"
            >
              <h6 class="files-section-title mt-2 mb-75">
                Files
              </h6>
              <div
                v-for="item in fileItems"
                :key="item.id"
                class="card file-manager-item folder file"
                :class="{ 'selected': resolveSelectedClass(item.ID) }"
                @click="onClickFile(item)"
              >
                <!-- <b-form-checkbox
                  v-model="itemSelected"
                  :value="item.ID"
                  class="custom-control-primary"
                  @input="toggleSelect(item)"
                                                      /> -->
                <div class="card-img-top file-logo-wrapper">
                  <div class="dropdown float-end d-none">
                    <feather-icon
                      icon="MoreVerticalIcon"
                      class="toggle-dropdown mt-n25"
                    />
                  </div>
                  <div class="d-flex align-items-center justify-content-center w-100 h-100">
                    <img
                      v-if="item.type === 'image'"
                      :src="item.file_local"
                      class="image-thumb"
                    >
                    <feather-icon
                      v-else-if="item.type === 'audio'"
                      :src="item.file_local"
                      icon="MusicIcon"
                      class="feather-icon"
                    />
                    <feather-icon
                      v-else-if="item.type === 'video'"
                      :src="item.file_local"
                      icon="VideoIcon"
                      class="feather-icon"
                    />
                    <feather-icon
                      v-else
                      icon="FileIcon"
                      class="feather-icon"
                    />
                  </div>
                </div>
                <div class="card-body">
                  <div class="content-wrapper">
                    <p class="card-text file-name mb-0">
                      <b-badge
                        v-b-tooltip
                        :variant="getMamStatusVariant(item.mam_status, item.file_proxy)"
                        class="badge-round file-status-badge"
                        :title="getMamStatusName(item.mam_status, item.file_proxy)"
                      />
                      {{ item.name }}
                    </p>
                    <p class="card-text file-size mb-0">
                      {{ convertSize(item.filesize) }}
                    </p>
                    <p class="card-text file-date">
                      {{ convertDate(item.created_at) }}
                    </p>

                  </div>

                  <small class="file-accessed text-muted">{{ convertDate(item.created_at) }}</small>
                  <!-- <div class="file-status">
                    <b-badge
                      :variant="getMamStatusVariant(item.mam_status)"
                      pill
                      class="badge-round file-status-badge mr-1"
                    >
                      {{ getMamStatusName(item.mam_status) }}
                    </b-badge>
                  </div> -->
                </div>
              </div>
              <div
                class="flex-grow-1 align-items-center no-result mb-3"
                :class="{ 'd-none': fileItems.length }"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  class="me-50"
                /> Không có kết quả
              </div>
            </div>
            <!-- /Files Container Ends -->
            <div
              v-if="totalEntries"
              class="mx-2 mb-2"
            >
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }}</span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >

                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalEntries"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>

                </b-col>

              </b-row>
            </div>
          </vue-perfect-scrollbar>
        </div>
        <!-- file manager app content ends -->
        <!-- File Info Sidebar Starts-->
        <!-- <FileInfo /> -->
        <!-- File Info Sidebar Ends -->
        <!-- File Dropdown Starts-->
        <!-- <FileDropdownStart /> -->
        <!-- /File Dropdown Ends -->
        <!-- Create New Folder Modal Starts-->
        <!-- <FileForm /> -->
        <!-- /Create New Folder Modal Ends -->
      </div>
    </div>

    <!-- MODAL UPLOAD -->
    <b-modal
      id="modalUploadFile"
      size="lg"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      title="Upload file"
      hide-footer
      ok-title="Đóng"
      @hidden="onHiddenModalUpload"
    >
      <file-upload
        ref="fileUploadRef"
        :auto-upload="true"
        @hide-modal-upload="hideModalUpload"
      />
    </b-modal>

    <!-- MODAL SEARCH -->
    <b-modal
      id="modalSearchFile"
      size="lg"
      title="Tìm kiếm nâng cao"
      hide-footer
      ok-title="Đóng"
      modal-class="modal modal-slide-in fade file-info-modal"
      content-class="p-0"
      body-class="flex-grow-1 pb-sm-0 pb-1"
    >
      <div class="py-1">
        <div class="form-group">
          <label>Từ khóa</label>
          <div class="input-group ">
            <input
              ref="searchInputRef"
              v-model="keyword"
              type="text"
              class="form-control files-filter"
              placeholder="tên,file"
              focus
              tabindex="0"
              @keyup.enter="searchFiles"
            >
            <div class="input-group-append">
              <button
                class="input-group-text"
                @click.prevent="searchFiles"
              >
                <feather-icon icon="SearchIcon" />
              </button>
            </div>

          </div>
        </div>
        <div class="form-group">
          <label>Thời lượng</label>
          <div class="input-group">
            <input
              v-model="durationFrom"
              type="text"
              class="form-control files-filter"
              placeholder="từ phút"
            >
            <input
              v-model="durationTo"
              type="text"
              class="form-control files-filter"
              placeholder="đến phút"
            >
            <div class="input-group-append">
              <label
                class="input-group-text"
                title="Thời lượng"
                @click.prevent="searchFiles"
              >
                <feather-icon icon="ClockIcon" />
              </label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Từ ngày</label>
          <div class="input-group">
            <flat-pickr
              ref="startDateRef"
              v-model="startDate"
              class="form-control"
              :config="configDate"
              placeholder="Từ ngày"
            />
            <div class="input-group-append">
              <button
                v-if="!startDate"
                class="input-group-text"
                type="button"
                @click.prevent="openStartDate"
              >
                <feather-icon icon="CalendarIcon" />
              </button>
              <button
                v-if="startDate"
                class="input-group-text"
                type="button"
                @click.prevent="clearStartDate"
              >
                <feather-icon icon="XIcon" />
              </button>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Đến ngày</label>
          <div class="input-group">
            <flat-pickr
              ref="endDateRef"
              v-model="endDate"
              class="form-control"
              :config="configDate"
              placeholder="Đến ngày"
            />
            <div class="input-group-append">
              <button
                v-if="!endDate"
                class="input-group-text"
                type="button"
                @click.prevent="openEndDate"
              >
                <feather-icon icon="CalendarIcon" />
              </button>
              <button
                v-if="endDate"
                class="input-group-text"
                type="button"
                @click.prevent="clearEndDate"
              >
                <feather-icon icon="XIcon" />
              </button>
            </div>
          </div>
        </div>
        <div class="row my-2">
          <!-- <div class="col-6">
            <b-form-checkbox
              v-model="searchAll"
              value="1"
              class="custom-control-primary"
            >
              Tìm tất cả
            </b-form-checkbox>
          </div> -->
          <div class="col-12 text-right">
            <a
              href="javascript:;"
              @click="resetSearchForm"
            >Làm mới</a>
          </div>
        </div>
        <div class="form-group">
          <button
            type="button"
            class="btn btn-primary btn-lg btn-block"
            @click="searchFiles"
          >
            Tìm kiếm
          </button>
        </div>
      </div>
    </b-modal>

    <!-- MODAL FILE INFO -->
    <file-info
      :file-data="itemSelected"
      @open-preview-file="openPreview"
      @open-audio-editor="openAudioEditor"
    />

    <!-- MODAL PREVIEW -->
    <b-modal
      id="modalPreviewFile"
      size="xlg"
      title="Xem thử"
      hide-footer
      ok-title="Đóng"
      content-class="p-0"
      body-class="p-1"
    >
      <div v-if="itemSelected">
        <img
          v-if="itemSelected.type === 'image'"
          :src="itemSelected.file_local"
          class="image-thumb"
        >
        <audio
          v-else-if="itemSelected.type === 'audio'"
          :src="itemSelected.file_local"
          class="audio-player"
          controls
          autoplay
          preload="auto"
          width="100%"
        />
        <video
          v-else-if="itemSelected.type === 'video'"
          :src="itemSelected.file_local"
          class="video-player"
          controls
          autoplay
          preload="auto"
          width="100%"
        />
        <a
          v-else
          :href="itemSelected.file_local"
        >{{ itemSelected.file_local }}</a>
      </div>
    </b-modal>

    <!-- MODAL AUDIO EDITOR -->
    <b-modal
      id="modalAudio"
      v-model="showModalAudioEditor"
      :title="`Biên tập audio: ` + (itemSelected ? itemSelected.name + '.' + itemSelected.extension : '')"
      size="xl"
      :ok-only="true"
      ok-title="Đóng"
      hide-footer
      centered
      body-class="p-0"
      no-close-on-backdrop
    >
      <audio-editor :file-data="itemSelected" />
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BButtonGroup, BBadge, BPagination, VBTooltip, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr from 'vue-flatpickr-component'
import { isMobile } from 'mobile-device-detect';
import { mapState } from 'vuex'
import FileInfo from './FileInfo.vue';
// import FileDropdownStart from './FileDropdownStart.vue';
import FileUpload from './FileUpload.vue';
import useFiles from '../useFiles';
import useFileManager from '../useFileManager';
import AudioEditor from './AudioEditor.vue';

export default {
  components: {
    BButton,
    BButtonGroup,
    BFormCheckbox,
    BBadge,
    BRow,
    BCol,
    BPagination,
    FileInfo,
    // FileForm,
    // FileDropdownStart,
    FileUpload,
    AudioEditor,
    flatPickr,
    VuePerfectScrollbar,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      fileData: null,
      isGrid: true,
      showModalAudioEditor: false,
      // fileData: null,
      itemSelected: { id: '', name: '', itemType: '' },
      perfectScrollbarSettings: {
        maxScrollbarLength: !isMobile ? 150 : 1000,
      },
      durationFrom: '',
      durationTo: '',
    }
  },
  setup() {
    const { configDate, configDateRange } = useFileManager();
    const {
      statusNames,
      statusVariants,
      mamStatusNames,
      mamStatusVariants,
      getMamStatusVariant,
      getMamStatusName,
      convertSize,
      convertDate,
    } = useFiles();

    return {
      statusNames,
      statusVariants,
      mamStatusNames,
      mamStatusVariants,
      getMamStatusVariant,
      getMamStatusName,
      convertSize,
      convertDate,
      configDate,
      configDateRange,

    }
  },
  computed: {
    ...mapState('files', {
      totalEntries: state => state.total,
      selectedCategory: state => state.selected_category,
      categoryItems: state => state.category_items,
      fileItems: state => state.file_items,
      isShowSidebar: state => state.show_sidebar,
      number_uploaded_files: state => state.number_uploaded_files,
    }),

    keyword: {
      get() { return this.$store.state.files.keyword },
      set(val) {
        this.$store.dispatch('files/setState', { keyword: val });
      },
    },
    startDate: {
      get() { return this.$store.state.files.start_date },
      set(val) {
        this.$store.dispatch('files/setState', { start_date: val });
      },
    },
    endDate: {
      get() { return this.$store.state.files.end_date },
      set(val) {
        this.$store.dispatch('files/setState', { end_date: val });
      },
    },
    currentPage: {
      get() { return this.$store.state.files.page },
      set(val) {
        this.$store.dispatch('files/setState', { page: val, show_all_category: (new Date()).getTime() });
      },
    },
    perPage: {
      get() { return this.$store.state.files.limit },
      set(val) { },
    },
    searchAll: {
      get() { return this.$store.state.files.search_all },
      set(val) {
        this.$store.dispatch('files/setState', { search_all: val });
      },
    },
    dataMeta() {
      return {
        from: this.$store.state.files.from,
        to: this.$store.state.files.to,
        of: this.$store.state.files.total,
      }
    },
    allowDelete() {
      return this.itemSelected.allow_delete
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$store.state.files.selected_category': function () {
      this.itemSelected = this.$store.state.files.selected_category;
      console.log('this.itemSelected', this.itemSelected);
      if (this.itemSelected.type === 'image' || this.itemSelected === 'video') {
        this.isGrid = true
      }
    },
  },
  mounted() {
    this.searchFiles();
    this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
      if (modalId === 'modalSearchFile') {
        this.focusSearchQuery();
      }
    })
  },
  methods: {
    openAudioEditor() {
      this.showModalAudioEditor = true;
      console.log('showModalAudioEditor', this.showModalAudioEditor);
    },
    closeAudioEditor() {
      this.showModalAudioEditor = false;
    },
    openPreview(fileData) {
      this.fileData = fileData;
      this.$bvModal.show('modalPreviewFile');
    },
    focusSearchQuery() {
      if (this.$refs.searchInputRef) {
        this.$refs.searchInputRef.focus();
      }
    },
    clearStartDate() {
      this.startDate = '';
    },
    clearEndDate() {
      this.endDate = '';
    },
    openStartDate() {
      this.$refs.startDateRef.$el.focus();
    },
    openEndDate() {
      this.$refs.endDateRef.$el.focus();
    },
    searchFiles() {
      this.$store.dispatch('files/setState', {
        loading: true,
        keyword: this.keyword,
        start_date: this.startDate,
        end_date: this.endDate,
        duration_from: this.durationFrom,
        duration_to: this.durationTo,
        search_all: this.searchAll,
        show_all_category: (new Date()).getTime(),
      });
      this.$bvModal.hide('modalSearchFile');
    },
    resolveSelectedClass(id, itemType) {
      return this.itemSelected.id === id && this.itemSelected.itemType === itemType;
    },
    showModalUpload() {
      this.$bvModal.show('modalUploadFile');
    },
    hideModalUpload() {
      this.$bvModal.hide('modalUploadFile');
    },
    onHiddenModalUpload() {
      if (this.number_uploaded_files) {
        this.searchFiles();
      }
    },
    toggleSidebarFile() {
      this.$store.dispatch('files/setState', { show_sidebar: !this.isShowSidebar });
    },
    refreshCategory() {
      this.$store.dispatch('files/setState', { show_all_category: (new Date()).getTime() });
    },
    onClickCategory(item) {
      this.itemSelected = item;
      this.$store.dispatch('files/setState', { selected_category: item });
      this.$store.dispatch('files/setState', { show_all_category: (new Date()).getTime() });
    },
    onClickFile(item) {
      this.itemSelected = item;
      this.itemSelected.category_name = this.selectedCategory ? this.selectedCategory.name : 'Uncategory';
      this.showFileInfo();
    },
    setListLayout(layout) {
      this.isGrid = layout === 'grid';
    },
    resetSearchForm() {
      this.$store.dispatch('files/setState', {
        keyword: '',
        start_date: '',
        end_date: '',
        duration_from: '',
        duration_to: '',
        search_all: 0,
        show_all_category: (new Date()).getTime(),
      });
    },
    toggleSelect(item) {
      this.itemSelected = item
    },
    showFileInfo() {
      this.$store.dispatch('files/setState', { show_file_info_modal: true });
    },
    deleteSelectedItem() {
      if (this.itemSelected && this.itemSelected.itemType === 'category') {
        this.$store.dispatch('files/setState', { loading: true });
        this.$store.dispatch('files/destroyCategory', { id: this.itemSelected.id })
          .then((res) => {
            if (res.status === 200) {
              if (res.data.code === 200) {
                this.$store.dispatch('files/setState', { deleted_category: this.itemSelected });
                this.fileItems = [];
                this.categoryItems = [];
              }
            }
            this.$store.dispatch('files/setState', { loading: false });
          })
      }
      if (this.itemSelected && this.itemSelected.itemType === 'file') {
        this.$store.dispatch('files/destroyFile', { id: this.itemSelected.id })
          .then((res) => {
            if (res.status === 200) {
              if (res.data.code === 200) {
                this.onClickCategory(this.selectedCategory.id)
              }
            }
            this.$store.dispatch('files/setState', { loading: false });
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#modalPreviewFile {

  img,
  video,
  audio {
    width: 100%;
  }
}

#modalSearchFile {
  .close {
    top: 0.5rem;
    background: none;
  }
}
</style>
